import {
  CHECKOUT_API_URL,
  SET_DELIVERY_METHOD_URL,
  FINALIZE_PAYMENT_URL,
  GET_DELIVERY_METHODS_URL
} from '../constants/endpoints';

export const initializePayment = () => {
  const method = 'POST';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = CHECKOUT_API_URL;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error;
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

export const getDeliveryMethods = () => {
  const method = 'GET';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = GET_DELIVERY_METHODS_URL;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error;
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

export const setDeliveryMethod = (deliveryMethodId, avardaSessionId) => {
  const method = 'POST';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = `${SET_DELIVERY_METHOD_URL}?deliveryMethod=${deliveryMethodId}${avardaSessionId ? `&purchaseId=${avardaSessionId}` : ''}`;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.status;
      }
      return response.error;
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

export const finalizePayment = avardaId => {
  const method = 'POST';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = `${FINALIZE_PAYMENT_URL}?purchaseId=${avardaId}`;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error;
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/checkoutApi.js